import { Link } from 'react-router-dom';

export function AuthShell({ titulo, subtitulo, children, rodape }) {
  return (
    <div className="bg-paper min-h-[calc(100vh-4.5rem)] px-4 py-14 sm:py-20">
      <div className="mx-auto w-full max-w-[26rem]">
        <div className="mb-8 text-center">
          <span className="text-wine text-2xl">✦</span>
          <h1 className="font-display text-ink mt-3 text-3xl leading-tight sm:text-[2.25rem]">
            {titulo}
          </h1>
          {subtitulo && (
            <p className="text-ink-soft/70 mt-2 text-sm">{subtitulo}</p>
          )}
        </div>

        <div className="border-petal rounded-3xl border bg-white p-7 shadow-[0_18px_40px_-28px_rgba(92,63,67,0.45)] sm:p-8">
          {children}
        </div>

        {rodape && (
          <p className="text-ink-soft/70 mt-6 text-center text-sm">{rodape}</p>
        )}
      </div>
    </div>
  );
}

export function CampoTexto({ rotulo, dica, erro, ...props }) {
  return (
    <label className="block">
      <span className="text-ink-soft/60 text-[0.68rem] font-semibold tracking-[0.14em] uppercase">
        {rotulo}
      </span>
      <input
        {...props}
        aria-invalid={erro ? 'true' : undefined}
        className={`text-ink placeholder:text-ink-soft/30 mt-1.5 w-full rounded-xl border bg-white px-4 py-3 text-sm transition-colors focus:outline-none ${
          erro
            ? 'border-accent focus:border-accent focus:ring-accent/15 focus:ring-2'
            : 'border-linen focus:border-wine focus:ring-wine/15 focus:ring-2'
        }`}
      />
      {erro ? (
        <span className="text-accent mt-1.5 block text-xs">{erro}</span>
      ) : (
        dica && (
          <span className="text-ink-soft/50 mt-1.5 block text-xs">{dica}</span>
        )
      )}
    </label>
  );
}

export function BotaoPrimario({ carregando, children, ...props }) {
  return (
    <button
      {...props}
      disabled={carregando || props.disabled}
      className="bg-wine hover:bg-wine-deep focus-visible:ring-wine/40 w-full rounded-full py-3.5 text-xs font-bold tracking-[0.16em] text-white uppercase transition-colors focus-visible:ring-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    >
      {carregando ? 'Aguarde…' : children}
    </button>
  );
}

export function AlertaErro({ children }) {
  if (!children) return null;
  return (
    <p
      role="alert"
      className="border-outline bg-blush-light text-accent rounded-xl border px-4 py-3 text-sm"
    >
      {children}
    </p>
  );
}

export function AlertaSucesso({ children }) {
  if (!children) return null;
  return (
    <p
      role="status"
      className="border-petal bg-blush-light text-ink-soft rounded-xl border px-4 py-3 text-sm"
    >
      {children}
    </p>
  );
}

export function LinkAuth({ to, children }) {
  return (
    <Link
      to={to}
      className="text-wine hover:text-wine-deep font-semibold underline-offset-4 transition-colors hover:underline"
    >
      {children}
    </Link>
  );
}
